(function() {
	angular.module('ShargoApp')
		.controller('ShargoProPageController', function ($rootScope, $scope, $timeout, $animate, $window, Configuration) {
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: $window.innerHeight - 75,
					background: 'linear-gradient(to bottom, #585757, #4a4a4a)',
					preheader: false,
					headerLink: $rootScope.url('shargopro-page'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargopro-white.svg" : Configuration.siteDomain + "/img/header/shargopro-mobile.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: $rootScope.url('enterprise-contact-pro'),
						text: 'header.contact',
						target: '',
						hide: true,
						disabled: false
					},
					profile: false
				}
			};

			/*  --VARIABLES--  */
			var positionInital = $rootScope.device.isVertical;
			$scope.servicesSection = [];
			for (var i = 0; i < 2; ++i){
				var array = [];
				for (var j = 0; j < 3; ++j){
					array.push({
						"title": "shargopro.page.main.services." + (j + i*3) + ".title",
						"extra": "shargopro.page.main.services." + (j + i*3) + ".extra",
						"subtitle": "shargopro.page.main.services." + (j + i*3) + ".subtitle",
						"image": $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/shargopro/page/service" + (j + i*3) + ".svg" : Configuration.siteDomain + "/img/shargopro/page/mobile-service" + (j + i*3) + ".svg"
					});
				}
				$scope.servicesSection.push(array);
			}

			$scope.servicesSlides = $scope.servicesSection[0].concat($scope.servicesSection[1]);
			$scope.servicesSlidesOptions = {
				sourceProp: 'image',
				perspective: 1,
				startSlide: 0,
				border: 0,
				width: 0,
				height: 0,
				dir: 'rtl',
				loop: true,
				autoRotationSpeed: 0,
				animationSpeed: 250,
				space: 160,
				visible: 3
			};

			$scope.customersDesktop = [];
			for (var i = 0; i < 3; ++i){
				var array = [];
				for (var j = 0; j < 4; ++j){
					var padding = 40;
					if ((j + i*4) == 0 || (j + i*4) == 9){
						padding = 20;
					}
					else if ((j + i*4) == 10){
						padding = 30;
					}
					else if ((j + i*4) == 4){
						padding = 50;
					}
					array.push({
						"image": Configuration.siteDomain + "/img/shargopro/page/customer" + (j + i*4) + ".png",
						"style": {'padding': padding + 'px'}
					});
				}
				$scope.customersDesktop.push(array);
			}
			$scope.customersMobile = [];
			var orderMobile = [[0, 8, 5, 2, 10, 7],[4, 1, 9, 6, 3, 11]];
			for (var i = 0; i < 2; ++i){
				var array = [];
				for (var j = 0; j < 6; ++j){
					var padding = 10;
					if (orderMobile[i][j] == 0 || orderMobile[i][j] == 9 || orderMobile[i][j] == 10){
						padding = 0;
					}
					else if (orderMobile[i][j] == 5){
						padding = 15;
					}
					else if (orderMobile[i][j] == 4){
						padding = 20;
					}
					array.push({
						"image": Configuration.siteDomain + "/img/shargopro/page/customer" + orderMobile[i][j] + ".png",
						"style": {'padding': padding + 'px'}
					});
				}
				$scope.customersMobile.push(array);
			}

			$scope.switch = { type: "tracing" };


			/*  --FUNCTIONS--  */
			function goDown() {
				angular.element("body").animate({scrollTop: $window.innerHeight - 75}, "slow");
			}

			function animateElementIn($el) {
				$el.removeClass('not-visible');
				$el.addClass('animated');

				if ($el[0].className.includes("info-section section")){
					updateHeight();
				}
			}

			function updateHeight() {
				//TOP
				if($rootScope.device.isDesktop || positionInital !== $rootScope.device.isVertical) {
					positionInital = $rootScope.device.isVertical;
					angular.element(".shargopro-page-container .top-section").css({
						"height": $window.innerHeight,
						"width": $window.innerWidth
					});
				}

				if(!$rootScope.device.isDesktop) {
					angular.element(".shargopro-page-container .top-section .section-arrow").css("bottom", $window.innerHeight - angular.element(".shargopro-page-container .top-section")[0].offsetHeight + 20 + "px");
				}

				//INFO-SECTION -> CONTENT-INFO
				var height = 0;
				var elements = angular.element(".shargopro-page-container .main-section .info-section .content-info > div");
				for (var i = 0; i < elements.length; ++i){
					if (elements[i].offsetHeight > height) {
						height = elements[i].offsetHeight;
					}
				}
				angular.element(".shargopro-page-container .main-section .info-section .content-info").css("min-height", height + "px");
			}


			/*  --ExECUTION--  */
			$scope.goDown = goDown;
			$scope.animateElementIn = animateElementIn;

			angular.element(document).ready(function () {
				$timeout(function() {
					//TOP
					positionInital = $rootScope.device.isVertical;
					angular.element(".shargopro-page-container .top-section").css({
						"height": $window.innerHeight,
						"width": $window.innerWidth
					});

					if(!$rootScope.device.isDesktop) {
						angular.element(".shargopro-page-container .top-section .section-arrow").css("bottom", $window.innerHeight - angular.element(".shargopro-page-container .top-section")[0].offsetHeight + 20 + "px");
					}

					//INFO-SECTION -> CONTENT-INFO
					var height = 0;
					var elements = angular.element(".shargopro-page-container .main-section .info-section .content-info > div");
					for (var i = 0; i < elements.length; ++i){
						if (elements[i].offsetHeight > height) {
							height = elements[i].offsetHeight;
						}
					}
					angular.element(".shargopro-page-container .main-section .info-section .content-info").css("min-height", height + "px");
					angular.element($window).bind('resize', updateHeight);
					$scope.$on('$destroy', function(event) {
						angular.element($window).unbind('resize', updateHeight);
					});
				});
			});
		});
})();